module.exports = __webpack_public_path__ + "files/0de1f6ab6588f2585e9a2441f45c301a.png";